var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "main-button-group text-center white--text",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3",
      "data-aos": "fade-up",
      "data-aos-duration": "600"
    }
  }, [_c('v-btn', {
    staticClass: "main-button-group__btn",
    attrs: {
      "x-large": "",
      "block": "",
      "height": _vm.$vuetify.breakpoint.mobile ? 80 : 80,
      "color": "#181d62",
      "to": "/mypage/cashes/charge"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "width": "42",
      "height": "39",
      "src": "/images/main/icon1.svg",
      "contain": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('span', {
    staticClass: "font-size-14 font-size-md-18 mt-4px mt-md-0 ml-md-10px"
  }, [_vm._v("나누리 충전")])])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3",
      "data-aos": "fade-up",
      "data-aos-duration": "600",
      "data-aos-delay": "100"
    }
  }, [!_vm.$vuetify.breakpoint.mobile ? _c('v-btn', {
    staticClass: "main-button-group__btn",
    attrs: {
      "x-large": "",
      "block": "",
      "height": _vm.$vuetify.breakpoint.mobile ? 80 : 80,
      "color": "#22298b",
      "to": "/gshop/brand"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "width": "42",
      "height": "39",
      "src": "/images/main/icon2.svg",
      "contain": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('span', {
    staticClass: "font-size-14 font-size-md-18 mt-4px mt-md-0 ml-md-10px"
  }, [_vm._v("상품권 교환소")])])], 1)], 1) : _vm._e(), _vm.$vuetify.breakpoint.mobile ? _c('v-btn', {
    staticClass: "main-button-group__btn",
    attrs: {
      "x-large": "",
      "block": "",
      "height": _vm.$vuetify.breakpoint.mobile ? 80 : 80,
      "color": "#22298b",
      "to": "/gshop/brand"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "width": "42",
      "height": "39",
      "src": "/images/main/icon2.svg",
      "contain": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('span', {
    staticClass: "font-size-14 font-size-md-18 mt-4px mt-md-0 ml-md-10px"
  }, [_vm._v("상품권 교환소")])])], 1)], 1) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3",
      "data-aos": "fade-up",
      "data-aos-duration": "600",
      "data-aos-delay": "150"
    }
  }, [_c('v-btn', {
    staticClass: "main-button-group__btn",
    attrs: {
      "x-large": "",
      "block": "",
      "height": _vm.$vuetify.breakpoint.mobile ? 80 : 80,
      "color": "#2c4fb4",
      "to": "/shop/exchange"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "width": "42",
      "height": "39",
      "src": "/images/main/icon3.svg",
      "contain": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('span', {
    staticClass: "font-size-14 font-size-md-18 mt-4px mt-md-0 ml-md-10px"
  }, [_vm._v("모바일 도서 교환권")])])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3",
      "data-aos": "fade-up",
      "data-aos-duration": "600",
      "data-aos-delay": "200"
    }
  }, [_c('v-btn', {
    staticClass: "main-button-group__btn",
    attrs: {
      "x-large": "",
      "block": "",
      "height": _vm.$vuetify.breakpoint.mobile ? 80 : 80,
      "color": "#366fd7",
      "to": "/mypage/cashes/inquiry"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "width": "42",
      "height": "39",
      "src": "/images/main/icon4.svg",
      "contain": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('span', {
    staticClass: "font-size-14 font-size-md-18 mt-4px mt-md-0 ml-md-10px"
  }, [_vm._v("캐시 내역")])])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }